import { createFileRoute } from '@tanstack/react-router';

import {
  AdminLinkedAccountsPage,
  peopleSearchSchema,
} from '@/features/organization-admin';

export const Route = createFileRoute('/admin/linked-accounts')({
  // The people list's search and slice live in the address (specs 160, 162),
  // as the Limits page's view does: a filtered view can be shared.
  validateSearch: peopleSearchSchema,
  component: AdminLinkedAccountsRoute,
});

export function AdminLinkedAccountsRoute() {
  const { q, show } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <AdminLinkedAccountsPage
      q={q ?? ''}
      show={show ?? 'all'}
      onChange={(next) => {
        void navigate({
          search: (prev) => ({ ...prev, ...next }),
          replace: true,
        });
      }}
    />
  );
}
